import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import useSubscriptionForm from "hooks/useSubscriptionForm";
import Spacer from "components/Spacer";
import Typography from "@material-ui/core/Typography";
import { ISubscriptionConfig } from "models/IAppConfig";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            flexDirection: "column",
        },
        subscriptionContainer: {
            display: "flex",
            [theme.breakpoints.down("sm")]: { flexDirection: "column" },
        },
        inputContainer: {},
        signuptButtonContainer: {
            marginLeft: theme.spacing(2),
            [theme.breakpoints.down("sm")]: {
                marginLeft: 0,
                width: "100%",
                display: "flex",
                justifyContent: "center",
            },
        },
    })
);

interface IProps {
    subscriptionConfig?: ISubscriptionConfig;
}

export default function PurchaseSubscriptionInput(props: IProps) {
    const classes = useStyles();

    const { subscriptionConfig = {} } = props;

    const { listName = "dirt5", checkboxLabel, description } = subscriptionConfig;

    const { inputComponent, signUpButton, termsLabel } = useSubscriptionForm({
        list: listName,
        termsLabel: <Typography variant="body1">{checkboxLabel}</Typography>,
    });

    return (
        <div className={classes.root}>
            <Typography variant="body1">{description}</Typography>

            <Spacer />

            <div className={classes.subscriptionContainer} style={{ display: "flex" }}>
                <div className={classes.inputContainer}>{inputComponent}</div>
                <div className={classes.signuptButtonContainer}>{signUpButton}</div>
            </div>

            <div>{termsLabel}</div>
        </div>
    );
}
